module.exports = __webpack_public_path__ + "img/banner(3).e97b5bd6.jpg";